import React from 'react';
import {RenderGoods} from "../components/catalog/RenderGoods";
import {withStore} from "../hocs";
import {observer} from "mobx-react";
import {RedirectAuthorizeIs} from "../components/auth/RedirectAuthorizeIs";
import {SidebarLeft} from "../components/tpl/SidebarLeft";
import {BreadCrumbs} from "../components/tpl/BreadCrumbs";


// @ts-ignore
@withStore
@observer
export default class CatalogSearchPageByCategory extends React.Component {

    componentDidMount() {
        // @ts-ignore
        const {store} = this.props;
        store?.componentTopSearchStore.initByCategory();
        store?.basePageStore.setBreadCrumbs([{url:'/catalog/search',name:'Поиск по категории'}],'catalog').setTitleInBreadCrumbs();
    }
    // search-catalog-by-category
    render() {
        // @ts-ignore
        const {store} = this.props;
        const {rows, isEmptyResult, statusSearch} = store?.componentTopSearchStore;
        
        const{user,includeUserLoyaltyProgram} = store?.mainStore;
        const {siteId}=user;
        // @ts-ignore
        const {title} = store?.basePageStore;
        return (
            <>
                <RedirectAuthorizeIs/>
                <div className="container">
                    <div className="columns">
                        <SidebarLeft/>
                        <div className="content">
                            <div className="breadcrumbs">
                                <div className="breadcrumbs-wrapper">
                                    <BreadCrumbs/>
                                </div>
                            </div>
                            <div className="catalog-title">
                                <h1 className="catalog-title__text">{title}</h1>
                            </div>
                            <RenderGoods siteId={siteId} items={rows} includeUserLoyaltyProgram={includeUserLoyaltyProgram} isEmptyResult={isEmptyResult} isLoading={statusSearch}/>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

